import { ChargeDetailRepoImpl } from "domain/repository/ChargeDetailMaintenance/ChargeDetailRepoImpl";
import { ChargeQtyAdjRepoImpl } from "domain/repository/ChargeQtyAdj/ChargeQtyAdjRepoImpl";
import { useManualChargeDetailTracked } from "presentation/store/ManualCharge/ManualChargeDetailProvider";
import { ManualChargeDetailVesselVM } from "presentation/viewModel/ManualCharge/ManualChargeDetailVesselVM";
import { useMemo } from "react";

export const useManualChargeDetailVesselVM = () => {
    const [, setManualChargeDetailState] = useManualChargeDetailTracked();
    const manualChargeDetailVesselVM = useMemo(() =>
        ManualChargeDetailVesselVM({
            dispatch: [setManualChargeDetailState],
            chargeDetailRepo: ChargeDetailRepoImpl(),
            repo: ChargeQtyAdjRepoImpl(),
        }), [setManualChargeDetailState])

    return manualChargeDetailVesselVM
}